<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    menuItem: { type: Object, required: true },
    menuName: { type: String, required: false },
  },

  computed: {
    styleClasses() {
      return Object.assign(
        {
          'topbar-contract-menu': true,
          'd-flex': true,
          'align-items-center': true,
          'sub-active': this.menuItem.active,
          disabled: this.menuItem.disabled,
          'ml-1/2': !!this.menuItem.icon && !this.menuItem.number,
        },
        this.menuItem.classes ?? {},
      )
    },
    show() {
      return this.menuItem.show ?? true // FIXME: Component should not be rendered at all
    },
  },

  methods: {
    dynamicLink() {
      this.$emit('navigate', this.menuItem.link)
    },
  },
}
</script>
<template>
  <div v-if="show" :class="styleClasses" :title="$t(menuItem.name)" @click="dynamicLink" :e2e-button="menuName">
    <div class="topbar-contract-circle">
      <span v-if="menuItem.number">{{ menuItem.number }}</span>
      <i v-if="menuItem.icon" :class="menuItem.icon"></i>
      <slot name="badge"></slot>
    </div>
    <span v-if="!menuItem.icon">{{ $t(menuItem.name) }}</span>
  </div>
</template>
